import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam, NzUploadFile, NzUploadModule, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { delay, of, take } from 'rxjs';
import { PhoneCallButtonComponent } from '../../../basic/buttons/phone-call-button/phone-call-button.component';
import { BarChartComponent } from '../../../basic/chart/bar-chart/bar-chart.component';
import { CoreItemService } from '../../../core/core-item/core-item.service';
import { SlackService } from '../../../core/slack/slack.service';
import { Tag } from '../../../core/tag/tag';
import { TagService } from '../../../core/tag/tag.service';
import { TestService } from '../../../core/test/test.service';
import { UnipileService } from '../../../core/unipile/unipile.service';
import { FileService } from './../../../core/file/file.service';

@Component({
  selector: 'app-test',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzButtonModule,
    NzIconModule,
    NzUploadModule,
    PhoneCallButtonComponent,
    BarChartComponent,
  ],
  templateUrl: './test.component.html',
  styleUrl: './test.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestComponent {
  data: any[] = [];
  tempAudioData: any[] = [];
  constructor(
    private msg: NzMessageService,
    private tagService: TagService,
    private slackService: SlackService,
    private fileService: FileService,
    private coreItemService: CoreItemService,
    private testService: TestService,
    private unipileService: UnipileService
  ) {}

  private _url: string | undefined;

  ngOnInit() {}

  private audioQueue: Int16Array[] = [];
  private isPlaying = false;

  fixBug() {
    this.unipileService
      .getMessageList$('Xf9qSFwMU76hYSQHfpK4dA')
      .pipe(take(1))
      .subscribe((data) => {
        console.log(data);
      });
  }

  sendSlackMessage() {
    this.slackService
      .sendMessage$('C07SHECCR46', [
        {
          type: 'section',
          text: {
            type: 'mrkdwn',
            text: 'Hello, world!',
          },
        },
      ])
      .pipe(take(1))
      .subscribe(() => {
        this.msg.success('Message sent successfully');
      });
  }

  playNextAudio() {
    if (this.audioQueue.length > 0 && !this.isPlaying) {
      this.isPlaying = true;
      const audioData = this.audioQueue.shift();
      if (audioData) {
        const audioContext = new window.AudioContext();
        const floatArray = new Float32Array(audioData.length);
        for (let i = 0; i < audioData.length; i++) {
          floatArray[i] = audioData[i] / 32768.0; // Convert Int16 to Float32
        }
        const audioBuffer = audioContext.createBuffer(1, floatArray.length, 24000); // Ensure correct sample rate
        audioBuffer.getChannelData(0).set(floatArray);
        const source = audioContext.createBufferSource();
        source.buffer = audioBuffer;
        source.connect(audioContext.destination);
        source.onended = () => {
          this.isPlaying = false;
          this.playNextAudio();
        };
        source.start();
      }
    }
  }

  async onRealtimeClientClick() {
    // const client = new RealtimeClient({
    //   apiKey: '',
    //   dangerouslyAllowAPIKeyInBrowser: true,
    // });
    // // Can set parameters ahead of connecting, either separately or all at once
    // client.updateSession({ instructions: 'You are a great, upbeat friend.' });
    // client.updateSession({ voice: 'alloy' });
    // client.updateSession({
    //   turn_detection: { type: 'server_vad' }, // or 'server_vad'
    //   input_audio_transcription: { model: 'whisper-1' },
    // });
    // // Set up event handling
    // client.on('conversation.updated', (event: any) => {
    //   const { item, delta } = event;
    //   const items = client.conversation.getItems();
    //   if (delta && delta.audio) {
    //     this.audioQueue.push(delta.audio);
    //     this.playNextAudio();
    //   }
    //   /**
    //    * item is the current item being updated
    //    * delta can be null or populated
    //    * you can fetch a full list of items at any time
    //    */
    //   console.log('-----event:', event);
    // });
    // await client.connect();
    // // Send a item and triggers a generation
    // client.sendUserMessageContent([{ type: 'input_text', text: `How are you?` }]);
  }

  onSendWeeklyReportClick() {
    this.coreItemService.sendWeeklyReport$().pipe(take(1)).subscribe();
  }

  onDeleteTagClick(tag: Tag) {
    this.tagService.deleteTagList$([tag]).pipe(take(1)).subscribe();
  }

  onTestChromeExtension() {
    document.dispatchEvent(
      new CustomEvent('sendUserInfoEvent', {
        detail: { accessToken: 'Hello from the website!' },
      })
    );
  }

  async uploadFileToS3(signedUrl: string) {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;

    console.log('-----fileInput:', fileInput.files);

    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];

      console.log('-----file.type:', file.type);
      try {
        const response = await fetch(signedUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': file.type, // Ensure the content type matches the file's MIME type
          },
        });

        if (response.ok) {
          console.log('File uploaded successfully');
        } else {
          console.error('Failed to upload file', response.statusText);
        }
      } catch (error) {
        console.error('Error uploading file', error);
      }
    } else {
      console.error('No file selected');
    }
  }

  // Add an event listener to the file input element to trigger the upload
  onChange() {
    this.uploadFileToS3(this._url!);
  }

  onS3SignedUrlClick() {
    this.fileService
      .getPresignedUrlToUpload$('upload_test.png')
      .pipe(take(1))
      .subscribe((data) => {
        this._url = data?.url;
      });
  }

  handleChange({ file, fileList }: NzUploadChangeParam): void {
    const status = file.status;

    console.log('-----handleChange:', status);
    if (status !== 'uploading') {
      // console.log(file, fileList);
    }
    if (status === 'done') {
      this.msg.success(`${file.name} file uploaded successfully.`);

      console.log('----- fileList:', fileList);

      fileList = fileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = (file.originFileObj as any)?.url ?? '';
        }
        return file;
      });
    } else if (status === 'error') {
      this.msg.error(`${file.name} file upload failed.`);
    }
  }

  uploadFileHandler = (item: NzUploadXHRArgs) => {
    console.log('-----item:', item);
    return of(true)
      .pipe(delay(1000), take(1))
      .subscribe(() => {
        if (item.onSuccess) {
          console.log('-----file:', item.file);
          console.log('-----file:', item.postFile);

          item.file.url = 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png';

          item.onSuccess!(
            'Success',
            item.file as NzUploadFile,
            'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
          );
        }
      });
  };

  // =================
  private mediaRecorder: MediaRecorder | null = null;
  private recordedChunks: Blob[] = [];

  private saveRecording() {
    const blob = new Blob(this.recordedChunks, {
      type: 'video/webm',
    });

    this.fileService
      .getPresignedUrlToUpload$('test_video.webm')
      .pipe(take(1))
      .subscribe(async (data) => {
        this._url = data?.url;

        const response = await fetch(this._url!, {
          method: 'PUT',
          body: blob,
          headers: {
            'Content-Type': 'video/webm', // Ensure the content type matches the file's MIME type
          },
        });

        if (response.ok) {
          console.log('File uploaded successfully');
        } else {
          console.error('Failed to upload file', response.statusText);
        }
      });

    // const fileName = `recording_${new Date().toISOString()}.webm`;
    // const file = new File([blob], fileName, { type: 'video/webm' });

    // this.fileService
    //   .saveFileToS3$(fileName, file)
    //   .pipe(take(1))
    //   .subscribe(
    //     (response) => {
    //       console.log('Recording uploaded successfully:', response.url);
    //     },
    //     (error) => {
    //       console.error('Error uploading recording:', error);
    //     }
    //   );

    // this.recordedChunks = [];
  }
}
